<div class="restrictions-table rt-table-wrap" [class.rt-tab]="tabLayout" [class.rt-default-sort]="isDefaultSort" [hidden]="totalCount === 0 && (tabLayout || loaded)">
  <mat-table [dataSource]="dataSource" class="rt-table" multiTemplateDataRows matSort matSortActive="company.name" matSortDirection="asc">

    <!-- Company Column -->
    <ng-container matColumnDef="company.name">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-md"
                       [ngClass]="{
                       active: sort?.active === 'company.name',
                       descending: sort?.active === 'company.name' && sort?.direction === 'desc'
                       }">
        Company
      </mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-md rt-company-cell">
        <i class="fa fa-angle-right rt-caret" aria-hidden="true" [ngClass]="{ 'expanded': expandedRows.has(restriction.id) }"></i>
        <div>
          <a href="/company/{{ restriction.company.id }}?tab=restrictions" target="_blank" class="rt-key"
             (click)="$event.stopPropagation()">{{ restriction.company.name }}</a>
          <span class="rt-sub">{{ restriction.company.isPrivate ? 'Private' : restriction.company.ticker }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef mat-sort-header="reason" class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'reason',
                       descending: sort?.active === 'reason' && sort?.direction === 'desc'
                       }">Type</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-sm">
        <span class="rt-nowrap"><span class="rt-key">{{ TradeRestrictionReasonLabels[restriction.reason] }}</span> | {{ TradeRestrictionLevelLabels[restriction.level] }}</span>
      </mat-cell>
    </ng-container>

    <!-- Net Level Column -->
    <ng-container matColumnDef="netLevel">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-xs"
                       [ngClass]="{
                       active: sort?.active === 'netLevel',
                       descending: sort?.active === 'netLevel' && sort?.direction === 'desc'
                       }">Net</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-xs">{{ TradeRestrictionLevelLabels[restriction.netLevel] }}</mat-cell>
    </ng-container>

    <!-- Person Column -->
    <ng-container matColumnDef="person.lastName">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-md"
                       [ngClass]="{
                       active: sort?.active === 'person.lastName',
                       descending: sort?.active === 'person.lastName' && sort?.direction === 'desc'
                       }">Person</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-md">
        <ng-container *ngTemplateOutlet="personName; context: { $implicit: restriction }"></ng-container>
      </mat-cell>
    </ng-container>

    <!-- Details Column -->
    <ng-container matColumnDef="details">
      <mat-header-cell *matHeaderCellDef class="w-restrict-lg rt-details-cell">Details</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-lg rt-details-cell">
        <ng-container *ngTemplateOutlet="detailsContent; context: { $implicit: restriction }"></ng-container>
      </mat-cell>
    </ng-container>

    <!-- Start Date Column -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'startDate',
                       descending: sort?.active === 'startDate' && sort?.direction === 'desc'
                       }">{{ tabLayout ? 'Since' : 'Start' }}</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-sm">
        <span *ngIf="restriction.startDate" class="rt-date">{{ restriction.startDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
      </mat-cell>
    </ng-container>

    <!-- End Date Column -->
    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'endDate',
                       descending: sort?.active === 'endDate' && sort?.direction === 'desc'
                       }">End</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-sm">
        <span *ngIf="restriction.endDate" class="rt-date">{{ restriction.endDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
      </mat-cell>
    </ng-container>

    <!-- End Reason Column -->
    <ng-container matColumnDef="endReason">
      <mat-header-cell *matHeaderCellDef class="w-restrict-lg">Remove Reason</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-lg">{{ restriction.endReason }}</mat-cell>
    </ng-container>

    <!-- Last Modified Column -->
    <ng-container matColumnDef="lastModified">
      <mat-header-cell *matHeaderCellDef mat-sort-header="updated" class="w-restrict-lg"
                       [ngClass]="{
                       active: sort?.active === 'updated',
                       descending: sort?.active === 'updated' && sort?.direction === 'desc'
                       }">Last Modified</mat-header-cell>
      <mat-cell *matCellDef="let restriction" class="w-restrict-lg rt-modified-cell">
        <div>
          <div class="rt-nowrap">{{ restriction.lastModifiedBy?.fullName }}</div>
          <ng-container *ngTemplateOutlet="modifiedDate; context: { $implicit: restriction }"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="rowActions; context: { $implicit: restriction }"></ng-container>
      </mat-cell>
    </ng-container>

    <!--  Expanded row content  -->
    <ng-container matColumnDef="expandedContent">
      <mat-cell *matCellDef="let restriction" class="expanded-content-cell">
        <mat-expansion-panel [expanded]="expandedRows.has(restriction.id)">
          <div class="expanded-content"><span class="rt-securities-label">Securities</span>{{ companySecurities.get(restriction.company.id) }}</div>
        </mat-expansion-panel>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let restriction; columns: displayedColumns" class="restriction-row data-row"
             [class.inactive-row]="!restriction.active" [class.rt-row-open]="expandedRows.has(restriction.id)"
             (click)="onRowClick(restriction)"></mat-row>
    <ng-container *ngIf="!tabLayout">
      <mat-row *matRowDef="let restriction; columns: ['expandedContent']" class="expanded-content-row" [ngClass]="{ 'active': expandedRows.has(restriction.id) }"></mat-row>
    </ng-container>
  </mat-table>
</div>

<!-- The tab's narrow layout: one card per record, switched on from the tab column's width (see the scss) -->
<div class="rt-cards" *ngIf="tabLayout && totalCount > 0" role="list">
  <div class="rt-card" role="listitem" *ngFor="let restriction of records">
    <div class="rt-card-title">
      <span class="rt-key">{{ TradeRestrictionReasonLabels[restriction.reason] }}</span><span class="rt-sep"> · </span>{{ TradeRestrictionLevelLabels[restriction.level] }}
    </div>
    <div class="rt-card-facts">
      <ng-container *ngTemplateOutlet="personName; context: { $implicit: restriction }"></ng-container>
      <ng-container *ngIf="restriction.startDate">
        <span class="rt-sep"> · </span>Since {{ restriction.startDate.toFormat(CONFIG.restrictionDateFormat) }}
      </ng-container>
    </div>
    <div class="rt-card-body" *ngIf="restriction.details || isBoardDerived(restriction) || !hasFullPermission(restriction)">
      <ng-container *ngTemplateOutlet="detailsContent; context: { $implicit: restriction }"></ng-container>
    </div>
    <div class="rt-card-meta">
      {{ restriction.lastModifiedBy?.fullName }}<span class="rt-sep"> · </span><ng-container *ngTemplateOutlet="modifiedDate; context: { $implicit: restriction, inline: true }"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="rowActions; context: { $implicit: restriction }"></ng-container>
  </div>
</div>

<div class="d-flex justify-content-end mb-2 rt-pager" *ngIf="showPager">
  <rms-pagination [pagination]="pagination"
                  [totalRecords]="totalCount"
                  (onPageChanged)="onPageChange()"
                  (onRecordsPerPageChanged)="onPageChange()"
  ></rms-pagination>
</div>

<rms-restriction-add-edit></rms-restriction-add-edit>
<rms-delete-confirmation></rms-delete-confirmation>
<rms-confirmation-modal #updateFailConfirm></rms-confirmation-modal>


<ng-template #lockedContent>
  <rms-permission-lock-popover></rms-permission-lock-popover>
</ng-template>

<!-- Person links to the Restrictions page's person filter; the tab doesn't filter, so it's plain text there -->
<ng-template #personName let-restriction>
  <a *ngIf="!tabLayout; else personText" href="javascript:void(0)" (click)="personClick.next(restriction.person); $event.stopPropagation()">
    {{ restriction.person?.fullName }}<span *ngIf="!restriction.person?.active" class="inactive-label"> (inactive)</span>
  </a>
  <ng-template #personText>
    {{ restriction.person?.fullName }}<span *ngIf="!restriction.person?.active" class="inactive-label"> (inactive)</span>
  </ng-template>
</ng-template>

<ng-template #detailsContent let-restriction>
  <ng-container *ngIf="hasFullPermission(restriction); else lockedContent">{{ restriction.details }}</ng-container>
  <div class="rt-managed" *ngIf="isBoardDerived(restriction)"><i class="fa fa-lock" aria-hidden="true"></i> Managed in Board Seats</div>
</ng-template>

<!-- Last Modified's date-time; on stale restrictions it turns orange and carries its age -->
<ng-template #modifiedDate let-restriction let-inline="inline">
  <ng-container *ngIf="restriction.lastModified">
    <ng-container *ngIf="getStaleMonths(restriction) as staleMonths; else freshDate">
      <span class="rt-stale" [class.rt-sub]="!inline"
            [title]="'Not updated in ' + staleMonths + ' months — check it is still current'">{{ restriction.lastModified.toFormat(CONFIG.restrictionDateTimeFormat) }} · {{ staleMonths }} mo</span>
    </ng-container>
    <ng-template #freshDate>
      <span [class.rt-sub]="!inline">{{ restriction.lastModified.toFormat(CONFIG.restrictionDateTimeFormat) }}</span>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #rowActions let-restriction>
  <button type="button" class="rms-row-kebab" *ngIf="hasRowActions(restriction)"
          [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{ restriction: restriction }"
          aria-label="Restriction actions" title="Actions"
          (click)="$event.stopPropagation()">
    <svg width="3" height="13" viewBox="0 0 3 15" fill="none" aria-hidden="true">
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor"/>
      <circle cx="1.5" cy="7.5" r="1.5" fill="currentColor"/>
      <circle cx="1.5" cy="13.5" r="1.5" fill="currentColor"/>
    </svg>
  </button>
</ng-template>

<mat-menu #rowMenu="matMenu" xPosition="before" class="rms-row-menu-panel">
  <ng-template matMenuContent let-restriction="restriction">
    <button mat-menu-item type="button" *ngIf="canEdit(restriction)" [disabled]="spinnerService.active"
            (click)="openRestrictionAddEdit(restriction)">
      <i class="fa fa-pencil" aria-hidden="true"></i><span>Edit</span>
    </button>
    <button mat-menu-item type="button" class="rms-row-menu-danger" *ngIf="canDelete(restriction)" [disabled]="spinnerService.active"
            (click)="deleteTradeRestriction(restriction)">
      <i class="fa fa-times-circle" aria-hidden="true"></i><span>Delete</span>
    </button>
  </ng-template>
</mat-menu>

<!-- The header row as a native row, rendered by the Restrictions page into its pinned copy on phones -->
<ng-template #pinnedHeadRow>
  <tr>
    <th *ngFor="let column of displayedColumns" [ngClass]="columnClass(column)"
        [class.active]="isSortedBy(column)" [class.descending]="isSortedBy(column) && sort.direction === 'desc'"
        [class.rt-sortable]="isSortable(column)" [class.rt-sorted-fill]="isSortedBy(column) && !isDefaultSort"
        scope="col" (click)="sortFromPin(column)" (keydown.enter)="sortFromPin(column)">{{ columnLabel(column) }}</th>
  </tr>
</ng-template>
